




























import { defineComponent } from "@vue/composition-api";
import { BAvatar, BButton } from "bootstrap-vue";

export default defineComponent({
    components: {
        BAvatar,
        BButton,
    },
    props: {
        variant: {
            type: String,
            default: "primary",
        },
        icon: {
            type: String,
            default: null,
        },
        title: {
            type: String,
            default: null,
        },
        text: {
            type: String,
            default: null,
        },
        html: {
            type: String,
            default: null,
        },
        button: {
            type: Object,
            default: null,
        },
        hideClose: {
            type: Boolean,
            default: false,
        },
    },
});
